import type { IconSvgObject } from './types';

const MailSearch02Icon: IconSvgObject = [
  ["path", { d: "M11 19H4C2.89543 19 2 18.1046 2 17V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.017 19.0233L22 21M21.0531 16.5265C21.0531 14.5789 19.4742 13 17.5265 13C15.5789 13 14 14.5789 14 16.5265C14 18.4742 15.5789 20.0531 17.5265 20.0531C19.4742 20.0531 21.0531 18.4742 21.0531 16.5265Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 7L10.9923 9.91215C11.615 10.2754 12.385 10.2754 13.0077 9.91215L18 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MailSearch02Icon;
